import { Types } from "@grandvisionhq/common";
const PrescriptionType = Types.PrescriptionType;
export {
  PrescriptionType
};
//# sourceMappingURL=prescription-glasses.js.map
